import React from 'react'

export default function BenefitSection({
  title,
  description,
  children,
  className = '',
}) {
  return (
    <div className={`space-y-6 ${className}`}>
      <div>
        {title && <div className="subtitle">{title}</div>}
        {description && <p className="mt-1">{description}</p>}
      </div>
      {children}
    </div>
  )
}
